import { render, staticRenderFns } from "./readCountLegacy.vue?vue&type=template&id=3450358c&"
import script from "./readCountLegacy.vue?vue&type=script&lang=ts&"
export * from "./readCountLegacy.vue?vue&type=script&lang=ts&"
import style0 from "./readCountLegacy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports